import React from 'react'
import { snakeCase } from 'lodash'

import { useTranslation } from '../state/translation'
import { StringService } from '../services'

export function useLabel (key, params) {
  const translation = useTranslation()

  return React.useMemo(
    () => {
      const messageKey = snakeCase(key)
      const message = translation[messageKey]

      if (!message) {
        return `#${messageKey}`
      }

      return StringService.format(message, params)
    },
    [key, params, translation]
  )
}
